export default "__VITE_ASSET__Be9TH_cq__"